import styled from 'styled-components';

import { maxWidth, minWidth } from 'styles/media-queries';

import { container } from 'styles/grid';
import {
  articleMargins,
  sectionMargins,
  spacer16,
  spacer24,
  spacer48,
  spacer80,
} from 'styles/spacers';
import { Headline, Cta as CtaComponent } from 'components/atoms';
import { black, white } from 'styles/colors';
import { levels } from 'styles/z-index';
import { scrollHorizontalInvisible } from 'styles/utils';

export const TileCarousel = styled.section`
  ${props => (props.fullWidth ? `width: 100%` : container)}
  ${props => props.isArticleMargin && articleMargins}
  ${props => !props.fullWidth && !props.isArticleMargin && sectionMargins}

  ${minWidth.lg`
    ${props =>
      props.isArticleMargin &&
      `
      display: grid;
      grid-template-columns: repeat(12, 1fr);
    `}
  `}
`;

export const Container = styled.section`
  position: relative;

  ${minWidth.lg`
    ${props =>
      props.isArticleMargin &&
      `
      grid-column: 3 / 11;
    `}
  `}
`;

export const TitleContainer = styled.div`
  padding-bottom: ${spacer48};
  color: ${props => (props.$titleColor ? props.$titleColor : white)};
  ${minWidth.lg`
    padding-bottom: ${spacer80};
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  `}
`;

export const Title = styled(Headline)`
  ${minWidth.lg`
    grid-column: span 6;
  `}
`;

export const DescriptionContainer = styled.div`
  ${minWidth.lg`
    grid-column: 8 / span 5;
  `}

  ${props =>
    props.hasDescription &&
    `
    display: flex;
    gap: ${spacer24};
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const Cta = styled(CtaComponent)`
  ${minWidth.lg`
    ${props =>
      !props.hasDescription &&
      `
      float: right;
    `}
  `}
`;

export const CtaContainer = styled.div`
  ${minWidth.lg`
    grid-column: 8 / span 5;
  `}
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  ${({ $direction }) => `${$direction}: -1px;`}
  width: ${spacer80};
  z-index: ${levels.highlight};

  --arrow-transition-duration: 0.3s;
  --arrow-transition-easing: cubic-bezier(0.4, 0, 0.2, 1);

  opacity: 0;
  pointer-events: none;
  transition: ${({ $isInitialized = true }) =>
    $isInitialized
      ? 'opacity var(--arrow-transition-duration) var(--arrow-transition-easing)'
      : 'none'};
  will-change: opacity;

  ${({ $isVisible }) =>
    $isVisible &&
    `
    opacity: 1;
    pointer-events: auto;
  `}

  @media (prefers-reduced-motion: reduce) {
    --arrow-transition-duration: 0.01ms;
  }

  /* visibility */
  ${maxWidth.md`
    display: none;
  `}

  ${minWidth.lg`
    display: flex;
    align-items: center;
    padding: 0 ${spacer16};
    justify-content: ${({ $direction }) =>
      $direction === 'left' ? 'flex-start' : 'flex-end'};

    /* Gradient background based on direction */
    background: linear-gradient(
      ${({
        // @ts-expect-error - minMax can not infer its parents type
        $direction,
      }) => ($direction === 'left' ? '90deg' : '270deg')},
      ${black} 0%,
      transparent 100%
    );
  `}
`;

export const RowContainer = styled.div`
  position: relative;
`;

export const TileContainer = styled.div`
  display: grid;
  grid-gap: ${spacer24};
  ${props =>
    props.$scrollHorizontalMobile &&
    `
      grid-template-rows: 1fr;
      grid-auto-columns: max-content;
      grid-auto-flow: column;
      overflow-x: scroll;
      -ms-overflow-style: none; /* for Internet Explorer, Edge /
      scrollbar-width: none; / for Firefox */
      overflow-y: clip;

      &::-webkit-scrollbar {
        display: none;
      }
  `}

  ${minWidth.lg`
    ${props =>
      props.$scrollHorizontal
        ? `
        grid-template-rows: 1fr;
        grid-auto-columns: max-content;
        grid-auto-flow: column;
        overflow-x: scroll;
        ${scrollHorizontalInvisible}
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        overflow-y: clip;
    `
        : `grid-template-columns: repeat(${props.$length}, 1fr);`}
  `}

  .carousel-card {
    ${props =>
      props.$isArticleMargin &&
      `
      .bold-stat {
        font-size: 8rem;
        line-height: 6rem;
        letter-spacing: -0.2rem;
      }
    `}
    ${props =>
      props.$scrollHorizontalMobile &&
      `
      width: 80vw;
    `}

    ${minWidth.sm`
      ${props =>
        props.$scrollHorizontal
          ? `height: 55rem; width: unset; aspect-ratio: 4 / 5;`
          : `width: unset; height: unset;`}
    `}
  }
`;
